import React from 'react';
import styled from 'styled-components'

const Menu = ({ children }) => {
  return (
    <Container>
      {children}
    </Container>
  );
}

// ESTILOS
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`

export { Menu }